// * Bootstrap libraries
import './_bootstrap';
import './_home';
import './_sama_elton'
import './_partenaires'
import './_temoignages-clients'
import './_a_propos'

// * Any other global site-wide JavaScript should be placed below.
jQuery(document).ready(function(){

  //Slider page nos implantations
  if(jQuery('#slider-implantation').length > 0) {
    const swiperThumbs = new Swiper(".navigation-slider-implantation", {
      slidesPerView: "auto",
      spaceBetween: 0,
      breakpoints: {
        1200: {
          slidesPerView: "auto"
        },
        992: {
          slidesPerView: "auto"
        },
        500: {
          slidesPerView: 1
        },
        0: {
          slidesPerView: 1
        }
      },
      watchSlidesProgress: true,
      slideToClickedSlide: true,
    });

    new Swiper(".main-slider-implantation", {
      speed: 1000,
      slidesPerView: 1,
      spaceBetween: 0,
      autoplay: { delay: 3000, disableOnInteraction: false },
      pagination: { el: ".swiper-pagination", clickable: true },
      thumbs: { swiper: swiperThumbs },
    });

  }

  //Solution entreprise page
  if(jQuery('#solution-entreprise-page').length > 0) {

    //Solution carburant
    new Swiper("#solution-carburant .slider-solution-carburant", {
      slidesPerView: 4,
      spaceBetween: 30,
      autoplay: {
        delay: 10000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        1200: {
          slidesPerView: 4
        },
        992: {
          slidesPerView: 3
        },
        500: {
          slidesPerView: 1
        },
        0: {
          slidesPerView: 1
        }
      },
    });
  }

  if(jQuery('body').hasClass('path-stations')) {
    jQuery(".bef-checkboxes input").change(function(){
      if((this).checked) {
        jQuery(this).addClass('checked');
      } else {
        jQuery(this).removeClass('checked');
      }
    });
  }

})

//Fixed menu on scroll
document.addEventListener('DOMContentLoaded', function() {
  var navbar = document.getElementById("newNav");

  // Vérifier que l'élément existe avant de continuer
  if (!navbar) {
    console.warn('Élément #navigation non trouvé');
    return;
  }

  let sticky = navbar.offsetTop;

  function myFunctionForSticky() {
    sticky = window.pageYOffset;
    if (window.pageYOffset >= sticky ) {
      navbar.classList.add("sticky");
    } else {
      navbar.classList.remove("sticky");
    }
    if(sticky === 0) {
      navbar.classList.remove("sticky");
    }
  }

  window.addEventListener('scroll', myFunctionForSticky);

  // Active le parent si un enfant est actif
  document.querySelectorAll('.menu-level-1 .nav-link.active').forEach(activeChild => {
    const parentButton = activeChild
      .closest('.sous-menu-nav')
      ?.previousElementSibling;

    if (parentButton && parentButton.tagName === 'BUTTON') {
      parentButton.classList.add('has-active-child');
    }
  });
});

// ============================================
// BURGER MENU MOBILE
// ============================================
document.addEventListener('DOMContentLoaded', function () {

  // Crée le bouton burger et l'overlay
  const nav = document.querySelector('.newNavigation');
  const container = nav.querySelector('.container');

  // Bouton burger
  const burger = document.createElement('button');
  burger.classList.add('burger-btn');
  burger.setAttribute('aria-label', 'Ouvrir le menu');
  burger.setAttribute('aria-expanded', 'false');
  burger.innerHTML = `
    <span class="burger-line"></span>
    <span class="burger-line"></span>
    <span class="burger-line"></span>
  `;

  // Overlay fond sombre
  const overlay = document.createElement('div');
  overlay.classList.add('nav-overlay');

  nav.prepend(burger);
  document.body.appendChild(overlay);

  // Toggle menu
  function toggleMenu(open) {
    burger.setAttribute('aria-expanded', open);
    burger.classList.toggle('is-open', open);
    container.classList.toggle('menu-open', open);
    overlay.classList.toggle('is-visible', open);
    document.body.classList.toggle('menu-locked', open); // bloque le scroll
  }

  burger.addEventListener('click', function () {
    const isOpen = burger.getAttribute('aria-expanded') === 'true';
    toggleMenu(!isOpen);
  });

  overlay.addEventListener('click', function () {
    toggleMenu(false);
  });

  // Ferme au resize desktop
  window.addEventListener('resize', function () {
    if (window.innerWidth >= 992) toggleMenu(false);
  });
});


// // ============================================
// // FERME LES AUTRES SOUS-MENUS — un seul à la fois
// // ============================================
// document.addEventListener('DOMContentLoaded', function () {
//
//   const submenuButtons = document.querySelectorAll(
//     '.menu-level-0 > .nav-item > button[data-bs-toggle="collapse"]'
//   );
//
//   submenuButtons.forEach(function (btn) {
//     btn.addEventListener('click', function () {
//       const targetId = btn.getAttribute('data-bs-target'); // ex: #submenu-2-0
//
//       submenuButtons.forEach(function (otherBtn) {
//         if (otherBtn === btn) return; // skip le bouton cliqué
//
//         const otherTargetId = otherBtn.getAttribute('data-bs-target');
//         const otherPanel = document.querySelector(otherTargetId);
//
//         if (otherPanel && otherPanel.classList.contains('show')) {
//           // Retire la classe show manuellement
//           otherPanel.classList.remove('show');
//           // Remet aria-expanded à false sur le bouton
//           otherBtn.setAttribute('aria-expanded', 'false');
//         }
//       });
//     });
//   });
//
// });
